import '../../styles/web-components/cart-progress-tiers.scss';
import { onCartUpdate } from '../services/cart.service';
const SECTION_ID = 'tiered-progress-data';
const ICONS = {
    truck: `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="10" cy="10" r="9.5" fill="#C5C5C5" stroke="#142D51"/>
<g clip-path="url(#clip0_385_1200)">
<path d="M7.69031 8.4353V11.2066H10.3331L7.69031 8.4353Z" fill="#8E2231"/>
<path d="M13.6001 8.77549C14.4727 8.77549 15.0149 9.42241 15.0149 10.4754V12.8827H14.4576C14.3226 12.4918 13.9457 12.2056 13.4942 12.2056C13.0579 12.2056 12.6821 12.4918 12.546 12.8827H12.1993V8.77549H13.6001ZM13.4942 13.7402C13.2231 13.7402 12.9974 13.5145 12.9974 13.2434C12.9974 12.9724 13.2231 12.7466 13.4942 12.7466C13.7653 12.7466 13.991 12.9724 13.991 13.2434C13.991 13.5145 13.7653 13.7402 13.4942 13.7402ZM11.6593 8.51953V12.8978H8.57484C8.5446 12.8978 8.51436 12.8978 8.49924 12.913C8.36424 12.5069 7.98732 12.2207 7.53588 12.2207C7.08444 12.2207 6.7086 12.522 6.57252 12.913C6.54228 12.8978 6.49692 12.8827 6.46776 12.8827H5.77549V7.72141H11.6733V8.51845H11.6593V8.51953ZM7.53588 13.7402C7.2648 13.7402 7.03908 13.5145 7.03908 13.2434C7.03908 12.9724 7.2648 12.7466 7.53588 12.7466C7.80696 12.7466 8.03268 12.9724 8.03268 13.2434C8.03268 13.5145 7.80696 13.7402 7.53588 13.7402ZM6.96456 6.38222H8.40852V7.22462H6.12217L6.96456 6.38222ZM8.93556 6.38222H10.4702L11.3126 7.22462H8.93556V6.38222ZM12.1853 7.42118V7.40606C12.1853 7.39094 12.1853 7.39094 12.1701 7.37582C12.1701 7.3607 12.155 7.3607 12.155 7.34558C12.155 7.34558 12.155 7.33046 12.1399 7.33046C12.1248 7.31534 12.1248 7.30022 12.1097 7.30022L10.7564 5.9459C10.7111 5.90054 10.6366 5.8703 10.5761 5.8703H8.6796H6.87384C6.79824 5.8703 6.73884 5.90054 6.69348 5.9459L5.33917 7.30022C5.32405 7.31534 5.32405 7.33046 5.30893 7.33046L5.29489 7.34558C5.29489 7.3607 5.27977 7.3607 5.27977 7.37582C5.27977 7.39094 5.27977 7.39094 5.26465 7.40606V7.42118V7.46654V13.1387C5.26465 13.2737 5.38561 13.3946 5.52061 13.3946H6.48396C6.5142 13.3946 6.52932 13.3946 6.55956 13.3795C6.63516 13.8612 7.05636 14.237 7.5672 14.237C8.064 14.237 8.4852 13.8763 8.55972 13.3946H8.60508H11.9606H12.5319C12.6227 13.8763 13.0287 14.237 13.5245 14.237C14.0213 14.237 14.4425 13.8763 14.5181 13.3946H15.2849C15.4199 13.3946 15.5408 13.2748 15.5408 13.1387V10.4754C15.5408 9.79825 15.3453 9.22693 14.9846 8.83489C14.6379 8.45905 14.1573 8.26357 13.6152 8.26357H12.2004V7.46654C12.1853 7.45142 12.1853 7.4363 12.1853 7.42118Z" fill="#142D51"/>
</g>
<defs>
<clipPath id="clip0_385_1200">
<rect width="16.2" height="16.2" fill="white" transform="translate(2.80005 1.60004)"/>
</clipPath>
</defs>
</svg>
`,
    'product-tag': `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="10" cy="10" r="9.5" fill="#C5C5C5" stroke="#142D51"/>
<path d="M14.7409 11.5125L11.5194 14.73C11.4293 14.82 11.3279 14.8875 11.2153 14.9325C11.1026 14.9775 10.99 15 10.8773 15C10.7647 15 10.6521 14.9775 10.5394 14.9325C10.4268 14.8875 10.3254 14.82 10.2353 14.73L6.25907 10.7587C6.17647 10.6762 6.11264 10.5806 6.06758 10.4719C6.02253 10.3631 6 10.2488 6 10.1288V6.9C6 6.6525 6.08824 6.44063 6.26471 6.26438C6.44118 6.08812 6.65332 6 6.90113 6H10.1339C10.2541 6 10.3705 6.02438 10.4831 6.07313C10.5957 6.12188 10.6934 6.1875 10.776 6.27L14.7409 10.2413C14.831 10.3313 14.8967 10.4325 14.938 10.545C14.9793 10.6575 15 10.77 15 10.8825C15 10.995 14.9793 11.1056 14.938 11.2144C14.8967 11.3231 14.831 11.4225 14.7409 11.5125ZM8.02753 8.7C8.21527 8.7 8.37484 8.63438 8.50626 8.50313C8.63767 8.37188 8.70338 8.2125 8.70338 8.025C8.70338 7.8375 8.63767 7.67813 8.50626 7.54688C8.37484 7.41563 8.21527 7.35 8.02753 7.35C7.8398 7.35 7.68023 7.41563 7.54881 7.54688C7.4174 7.67813 7.35169 7.8375 7.35169 8.025C7.35169 8.2125 7.4174 8.37188 7.54881 8.50313C7.68023 8.63438 7.8398 8.7 8.02753 8.7Z" fill="#142D51"/>
</svg>
`,
    check: `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="10" cy="10" r="9.5" fill="#2F71D4" stroke="#142D51"/>
<path d="M8.86364 12.0373L6.71591 9.84328L6 10.5746L8.86364 13.5L15 7.23134L14.2841 6.5L8.86364 12.0373Z" fill="#142D51"/>
</svg>
`,
};
class CartProgressTiers extends HTMLElement {
    cartStateSub;
    connectedCallback() {
        this.cartStateSub = onCartUpdate.subscribe((cart) => {
            this.onCartUpdate(cart);
        });
    }
    disconnectedCallback() {
        this.cartStateSub?.();
    }
    parseSectionHtml(html) {
        const tmp = document.createElement('div');
        tmp.innerHTML = html;
        const script = tmp.querySelector(`#${SECTION_ID}`);
        if (script?.textContent) {
            try {
                return JSON.parse(script.textContent);
            }
            catch {
                return null;
            }
        }
        return null;
    }
    readDomSectionData() {
        const script = document.getElementById(SECTION_ID);
        if (script?.textContent) {
            try {
                return JSON.parse(script.textContent);
            }
            catch {
                return null;
            }
        }
        return null;
    }
    getSectionData(cart) {
        const sectionHtml = cart.sections?.[SECTION_ID];
        if (sectionHtml) {
            const parsed = this.parseSectionHtml(sectionHtml);
            if (parsed) {
                // Keep the DOM script tag in sync so the next page-load read is accurate.
                const domScript = document.getElementById(SECTION_ID);
                if (domScript) {
                    domScript.textContent = JSON.stringify(parsed);
                }
                return parsed;
            }
        }
        return this.readDomSectionData();
    }
    onCartUpdate(cart) {
        const data = this.getSectionData(cart);
        if (!data?.tiers.length)
            return;
        this.render(data);
    }
    render(data) {
        const { tiers, type, currency } = data;
        const valueForTier = (tier) => {
            const raw = tier.ignoreCollection
                ? (type === 'price' ? data.cartSubtotal : data.cartQuantity)
                : (type === 'price' ? data.eligibleSubtotal : data.eligibleQuantity);
            return type === 'price' ? raw / 100 : raw;
        };
        // Markers are evenly spaced: N tiers → N+1 equal segments (leading + gaps + tail).
        // Tier k sits at position (k+1)/(N+1). The tail after the last tier mirrors the
        // leading segment, and reaching the last tier snaps the fill to 100%.
        const n = tiers.length;
        const segmentWidth = 1 / (n + 1);
        const nextTier = tiers.find(t => valueForTier(t) < t.threshold);
        const nextIndex = nextTier ? tiers.indexOf(nextTier) : -1;
        let fillPercent;
        if (!nextTier) {
            fillPercent = 100;
        }
        else {
            const cv = valueForTier(nextTier);
            if (nextIndex === 0) {
                // Leading segment: 0 → tier[0].threshold maps to 0 → segmentWidth
                const fraction = tiers[0].threshold > 0
                    ? Math.min(cv / tiers[0].threshold, 1)
                    : 0;
                fillPercent = fraction * segmentWidth * 100;
            }
            else {
                // Inter-tier segment: tier[k-1].threshold → tier[k].threshold maps to k*segmentWidth → (k+1)*segmentWidth
                const prevThreshold = tiers[nextIndex - 1].threshold;
                const segmentRange = nextTier.threshold - prevThreshold;
                const fraction = segmentRange > 0
                    ? Math.min(Math.max((cv - prevThreshold) / segmentRange, 0), 1)
                    : 0;
                fillPercent = (nextIndex + fraction) * segmentWidth * 100;
            }
        }
        // Build message from every tier's current state, joined by a space.
        // Theme maintainers can open a new line by starting a label with <br>.
        // When all tiers are reached the section-level allQualifiedLabel takes over.
        const message = !nextTier
            ? (data.allQualifiedLabel || tiers[tiers.length - 1].qualifiedLabel)
            : tiers.map(tier => {
                const reached = valueForTier(tier) >= tier.threshold;
                return reached
                    ? tier.qualifiedLabel
                    : tier.promoLabel.replace('{value}', formatValue(type, currency, tier.threshold - valueForTier(tier)));
            }).join(' ');
        // On subsequent renders update only what changes so the fill element persists
        // and the CSS width transition fires naturally without jumping.
        const existingFill = this.querySelector('.cart-progress-tiers__fill');
        const existingMarkers = this.querySelectorAll('.cart-progress-tiers__marker');
        if (existingFill && existingMarkers.length === tiers.length) {
            existingFill.style.width = `${fillPercent}%`;
            const messageEl = this.querySelector('.cart-progress-tiers__message');
            if (messageEl)
                messageEl.innerHTML = message;
            tiers.forEach((tier, index) => {
                const markerEl = existingMarkers[index];
                const reached = valueForTier(tier) >= tier.threshold;
                markerEl.classList.toggle('cart-progress-tiers__marker--reached', reached);
                const iconEl = markerEl.querySelector('.cart-progress-tiers__marker-icon');
                if (iconEl)
                    iconEl.innerHTML = ICONS[reached ? 'check' : tier.icon];
            });
            return;
        }
        // Initial render (or tier count changed): build full HTML then animate fill in.
        const promoBannerHtml = data.promoBanner
            ? `<div class="cart-progress-tiers__promo-banner">${data.promoBanner}</div>`
            : '';
        const disclaimerHtml = data.disclaimer
            ? `<div class="cart-progress-tiers__disclaimer">${data.disclaimer}</div>`
            : '';
        const markers = tiers.map((tier, index) => {
            const position = (index + 1) * segmentWidth * 100;
            const reached = valueForTier(tier) >= tier.threshold;
            const iconKey = reached ? 'check' : tier.icon;
            return `
        <div
          class="cart-progress-tiers__marker${reached ? ' cart-progress-tiers__marker--reached' : ''}"
          style="left:${position}%"
        >
          <div class="cart-progress-tiers__marker-icon">${ICONS[iconKey]}</div>
          <div class="cart-progress-tiers__marker-label">${tier.label}</div>
        </div>
      `;
        }).join('');
        this.innerHTML = `
      <div class="cart-progress-tiers">
        ${promoBannerHtml}
        <div class="cart-progress-tiers__message">${message}</div>
        <div class="cart-progress-tiers__track-container" aria-hidden="true">
          <div class="cart-progress-tiers__fill" style="width:0"></div>
          ${markers}
        </div>
        ${disclaimerHtml}
      </div>
    `;
        // Double rAF ensures the element is painted at width:0 before the transition starts.
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                const fill = this.querySelector('.cart-progress-tiers__fill');
                if (fill)
                    fill.style.width = `${fillPercent}%`;
            });
        });
    }
}
function formatValue(type, currency, remaining) {
    if (type === 'price') {
        return `${currency}${remaining.toFixed(2)}`;
    }
    const count = Math.ceil(remaining);
    return `${count} item${count !== 1 ? 's' : ''}`;
}
if (!window.customElements.get('cart-progress-tiers')) {
    customElements.define('cart-progress-tiers', CartProgressTiers);
}
export const _forTesting = {
    formatValue,
};
